import { render } from "./종합건강검진절차.vue?vue&type=template&id=3540661c"
import script from "./종합건강검진절차.vue?vue&type=script&lang=js"
export * from "./종합건강검진절차.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__